import { isMacintosh, isNative, isWeb, isLinux } from 'monaco-editor/esm/vs/base/common/platform.js';
const WindowMinimumSize = {
    WIDTH: 400,
    WIDTH_WITH_VERTICAL_PANEL: 600,
    HEIGHT: 270
};
function isWorkspaceToOpen(uriToOpen) {
    return !!uriToOpen.workspaceUri;
}
function isFolderToOpen(uriToOpen) {
    return !!uriToOpen.folderUri;
}
function isFileToOpen(uriToOpen) {
    return !!uriToOpen.fileUri;
}
function getMenuBarVisibility(configurationService) {
    const titleBarStyle = getTitleBarStyle(configurationService);
    const menuBarVisibility = configurationService.getValue('window.menuBarVisibility');
    if (menuBarVisibility === 'default' || (titleBarStyle === 'native' && menuBarVisibility === 'compact') || (isMacintosh && isNative)) {
        return 'classic';
    }
    else {
        return menuBarVisibility;
    }
}
function getTitleBarStyle(configurationService) {
    if (isWeb) {
        return 'custom';
    }
    const configuration = configurationService.getValue('window');
    if (configuration) {
        const useNativeTabs = isMacintosh && configuration.nativeTabs === true;
        if (useNativeTabs) {
            return 'native';
        }
        const useSimpleFullScreen = isMacintosh && configuration.nativeFullScreen === false;
        if (useSimpleFullScreen) {
            return 'native';
        }
        const style = configuration.titleBarStyle;
        if (style === 'native' || style === 'custom') {
            return style;
        }
    }
    return isLinux ? 'native' : 'custom';
}
export { WindowMinimumSize, getMenuBarVisibility, getTitleBarStyle, isFileToOpen, isFolderToOpen, isWorkspaceToOpen };
